module.exports = __webpack_public_path__ + "img/gx_logo.df635517.png";